module.exports = __webpack_public_path__ + "img/80400.caa986ee.jpg";